<template>
  <div>
    <el-form :model="fromData" label-width="200px" :rules="rules">
      <span style="font-size: 16px;font-weight: bold">物件信息：</span>
      <div style="border: #e7e7e7 1px solid">
        <el-row style="margin-top: 20px">
          <el-form-item label="物件番号：">
            <el-input class="inputStyle" v-model="fromData.wujian_id" disabled></el-input>
          </el-form-item>
          <el-form-item label="物件略称：">
            <el-input class="inputStyle" v-model="fromData.wujian_name" disabled></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="楼层：">
            <el-input class="inputStyle" v-model="fromData.floor" disabled></el-input>
          </el-form-item>
          <el-form-item label="先行楼层：">
            <el-input class="inputStyle" v-model="fromData.advance_floor" disabled></el-input>
          </el-form-item>
        </el-row>
      </div>
      <span style="font-size: 16px;font-weight: bold">先行计划：</span>
      <div style="border: #e7e7e7 1px solid">
        <el-form-item label="展开结束：" style="margin-top: 20px">
          <el-date-picker v-model="fromData.expand_end_date" disabled style="width: 200px" type="date"
                          format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>
        </el-form-item>
        <el-row>
          <el-form-item label="加工计划开始：">
            <el-date-picker v-model="fromData.jiagong_plan_start_date" disabled style="width: 200px" type="date"
                            format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>
          </el-form-item>
          <el-form-item label="加工计划结束：">
            <el-date-picker v-model="fromData.jiagong_plan_end_date" disabled style="width: 200px" type="date"
                            format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="涂装计划开始：">
            <el-date-picker class="dateItemStyle" v-model="fromData.tuzhuang_plan_start_date" disabled
                            style="width: 200px" type="date" format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>
          </el-form-item>
          <el-form-item label="涂装计划结束：">
            <el-date-picker v-model="fromData.tuzhuang_plan_end_date" disabled style="width: 200px" type="date"
                            format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="组立计划开始">
            <el-date-picker v-model="fromData.zuli_plan_start_date" disabled style="width: 200px" type="date"
                            format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>
          </el-form-item>
          <el-form-item label="组立计划结束：">
            <el-date-picker v-model="fromData.zuli_plan_end_date" disabled type="date" style="width: 200px"
                            format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="出荷：">
            <el-date-picker v-model="fromData.outbound_date" disabled style="width: 200px" type="date"
                            format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>
          </el-form-item>
          <el-form-item label="搬入：">
            <el-date-picker v-model="fromData.move_in_date" disabled style="width: 200px" type="date"
                            format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>
          </el-form-item>
        </el-row>
      </div>
      <span style="font-size: 16px;font-weight: bold">生产进度：</span>
      <div style="border: #e7e7e7 1px solid">
        <el-row style="margin-top: 20px">
          <el-form-item label="加工进度：">
            <el-input class="inputStyle" disabled>
              <template #prepend>
                <span>{{fromData.jg_schedule+'%'}}</span>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="涂装进度：">
            <el-input class="inputStyle" disabled>
              <template #prepend>
                <span>{{fromData.tz_schedule+'%'}}</span>
              </template>
            </el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="组立进度：">
            <el-input class="inputStyle" disabled>
              <template #prepend>
                <span>{{fromData.zl_schedule+'%'}}</span>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="出荷进度：">
            <el-input class="inputStyle" disabled>
              <template #prepend>
                <span>{{fromData.outbound_schedule+'%'}}</span>
              </template>
            </el-input>
          </el-form-item>
        </el-row>
      </div>
<!--      <span style="font-size: 16px;font-weight: bold">加工情况：</span>-->
<!--      <div style="border: #e7e7e7 1px solid">-->
<!--        <el-row style="margin-top: 20px">-->
<!--          <el-form-item label="计划重量(KG)：">-->
<!--            <el-input class="inputStyle" v-model="fromData.weight" disabled></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="计划面积(㎡)：">-->
<!--            <el-input class="inputStyle" v-model="fromData.area" disabled></el-input>-->
<!--          </el-form-item>-->
<!--        </el-row>-->
<!--        <el-row>-->
<!--          <el-form-item label="结余重量(KG)：">-->
<!--            <el-input class="inputStyle" v-model="fromData.jg_balance_weight" disabled></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="结余面积(㎡)：">-->
<!--            <el-input class="inputStyle" v-model="fromData.jg_balance_area" disabled></el-input>-->
<!--          </el-form-item>-->
<!--        </el-row>-->
<!--      </div>-->
      <span style="font-size: 16px;font-weight: bold">组立情况：</span>
      <div style="border: #e7e7e7 1px solid">
        <el-row style="margin-top: 20px" v-if="!this.parentData.is_balance">
          <el-form-item label="计划重量(kg)：" label-width="170px">
            <el-input class="inputWidthStyle" v-model="fromData.weight" disabled></el-input>
          </el-form-item>
          <el-form-item label="计划单元个数(个)：" label-width="170px">
            <el-input class="inputWidthStyle" v-model="fromData.unit_num" disabled></el-input>
          </el-form-item>
          <el-form-item label="计划面积(㎡)：" label-width="170px">
            <el-input class="inputWidthStyle" v-model="fromData.area" disabled></el-input>
          </el-form-item>
        </el-row>
        <el-row style="margin-top: 20px" v-if="this.parentData.is_balance">
          <el-form-item label="计划重量(kg)：" label-width="170px">
            <el-input class="inputWidthStyle" v-model="this.zl_balance_weight" disabled></el-input>
          </el-form-item>
          <el-form-item label="计划单元个数(个)：" label-width="170px">
            <el-input class="inputWidthStyle" v-model="this.zl_balance_unit_num" disabled></el-input>
          </el-form-item>
          <el-form-item label="计划面积(㎡)：" label-width="170px">
            <el-input class="inputWidthStyle" v-model="this.zl_balance_area" disabled></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="结余重量(kg)：" label-width="170px">
            <el-input class="inputWidthStyle" v-model="fromData.zl_balance_weight"></el-input>
          </el-form-item>
          <el-form-item label="结余单元个数(个)：" label-width="170px">
            <el-input class="inputWidthStyle" v-model="fromData.zl_balance_unit_num"></el-input>
          </el-form-item>
          <el-form-item label="结余面积(㎡)：" label-width="170px">
            <el-input class="inputWidthStyle" v-model="fromData.zl_balance_area"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="结余批号："  label-width="170px">
            <el-input style="width: 700px;" v-model="fromData.balance_batch_no"></el-input>
          </el-form-item>
        </el-row>
      </div>
      <el-row>
        <span style="font-size: 16px;font-weight: bold;margin-top: 10px">结余计划：</span>
        <el-form-item label="结余计划年月：" label-width="350px" style="margin-top: 10px">
          <el-date-picker v-model="fromData.balance_date" disabled style="width: 200px" type="date"
                          format=" YYYY 年 M 月 " value-format="YYYY-M"/>
        </el-form-item>
      </el-row>

      <div style="border: #e7e7e7 1px solid;margin-top: -10px">
        <el-form-item label="展开结束：" style="margin-top: 20px">
          <el-date-picker v-model="fromData.balance_expand_end_date" disabled style="width: 200px" type="date"
                          format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>
        </el-form-item>
        <el-row>
          <el-form-item label="加工计划开始：">
            <el-date-picker v-model="fromData.jiagong_balance_plan_start" disabled style="width: 200px" type="date"
                            format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>
          </el-form-item>
          <el-form-item label="加工计划结束：">
            <el-date-picker v-model="fromData.jiagong_balance_plan_end" disabled style="width: 200px" type="date"
                            format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="涂装计划开始：">
            <el-date-picker class="dateItemStyle" v-model="fromData.tuzhuang_balance_plan_start" disabled style="width: 200px"
                            type="date" format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>
          </el-form-item>
          <el-form-item label="涂装计划结束：">
            <el-date-picker v-model="fromData.tuzhuang_balance_plan_end" disabled style="width: 200px" type="date"
                            format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="组立计划开始">
            <el-date-picker v-model="fromData.zuli_balance_plan_start" style="width: 200px" type="date"
                            format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>
          </el-form-item>
          <el-form-item label="组立计划结束：">
            <el-date-picker v-model="fromData.zuli_balance_plan_end" type="date" style="width: 200px"
                            format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="出荷：">
            <el-date-picker v-model="fromData.balance_outbound_date" style="width: 200px" type="date"
                            format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>
          </el-form-item>
          <el-form-item label="搬入：">
            <el-date-picker v-model="fromData.balance_move_in_date" style="width: 200px" type="date" format="YYYY-MM-DD"
                            value-format="YYYY-MM-DD"/>
          </el-form-item>
        </el-row>
      </div>
      <el-form-item></el-form-item>
      <el-row>
        <el-col :span="24" style="text-align: center">
          <el-button type="primary" @click="createBalanceData" :loading="loading">保存</el-button>
        </el-col>
      </el-row>
    </el-form>

  </div>
</template>

<script>
export default {
  name: "MfgWujianPlanBalance",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      batchNoDataList: [],
      cnt: 0,
      fromData: {
        balance_date: '',
      },
      zl_balance_weight:'',
      zl_balance_unit_num:'',
      zl_balance_area:'',
      zuLiPlanDateList: [],
      rules: {
        star: [{required: true, message: '', trigger: 'blur'}],
      },
    }
  },
  computed: {
    stateList() {
      return this.$store.getters['core/getDictList']('window_error_states');
    }
  },
  methods: {
    getDateFormat(){
      let month = new Date().getMonth() + 1
      return new Date().getUTCFullYear().toString() + "-" + month.toString()
    },
    //获取结余数据
    getWujianBalanceData() {
      this.fromData = this.parentData
      this.$axios.post('mfg/wujianPlan/getWujianBalanceData', this.fromData).then(response => {
        let res = response.data
        if (this.parentData.is_balance){
          this.zl_balance_weight = this.parentData.zl_balance_weight
          this.zl_balance_unit_num = this.parentData.zl_balance_unit_num
          this.zl_balance_area = this.parentData.zl_balance_area
        }
        this.fromData.jg_balance_weight = res.data.jg_balance_weight
        this.fromData.jg_balance_area = res.data.jg_balance_area
        this.fromData.zl_balance_weight = res.data.zl_balance_weight
        this.fromData.zl_balance_area = res.data.zl_balance_area
        this.fromData.zl_balance_unit_num = res.data.zl_balance_unit_num
        this.fromData.balance_batch_no = res.data.balance_batch_no
        this.fromData.balance_date = this.getDateFormat()
        this.fromData.balance_expand_end_date =  this.parentData.expand_end_date
        this.fromData.jiagong_balance_plan_start =  this.parentData.jiagong_plan_start_date
        this.fromData.jiagong_balance_plan_end =  this.parentData.jiagong_plan_end_date
        this.fromData.tuzhuang_balance_plan_start =  this.parentData.tuzhuang_plan_start_date
        this.fromData.tuzhuang_balance_plan_end =  this.parentData.tuzhuang_plan_end_date
        this.fromData.zuli_balance_plan_start =  res.data.zuli_balance_plan_start
        this.fromData.zuli_balance_plan_end =  res.data.zuli_balance_plan_end
        this.fromData.balance_outbound_date =  res.data.balance_outbound_date
        this.fromData.balance_move_in_date =  this.parentData.move_in_date
      }, error => {
        this.$message.error(`获取数据失败` + error.message);
      })
    },
    createBalanceData() {
      this.loading = true
      this.$axios.post('mfg/wujianPlan/createBalanceData', this.fromData).then(response => {

        let res = response.data
        if (res.code !== 0) {
          this.loading = false
          return this.$message.error(res.message);
        }
        this.loading = false
        this.setting.$fn.closeWindow();
        this.setting.$fn.reSearch();
        return this.$message.success('编辑成功!');
      })
    },
  }, created() {
    this.getWujianBalanceData()
  }
}
</script>

<style scoped>
.inputStyle {
  width: 200px;
}

.inputWidthStyle {
  width: 120px;
}

.dateItemStyle {
  width: 150px;
}

.left-aligned-slot {
  display: inline-block;
  text-align: left;
}

.height {
  line-height: 40px;
  height: 40px;
}
</style>